"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('observer.navigation', function () {
    this.frameId = false; // Has to be passed
    this.init = function () {
        namespace_1.default.debug.showInfo('Starting observer.navigation');
        (0, jquery_1.default)(document).on(this.frameId + namespace_1.default.events.framework.done, this.start.bind(this));
    };
    this.start = function () {
        namespace_1.default.debug.showError('navigation.start has not been extended');
    };
});
